import { REMOVE_ERROR_MESSAGE } from 'ACTIONS';
import isArray from 'lodash/isArray';
import __values from 'lodash/values';

export const removeErrorMsg = errors => (dispatch) => {
    const list = isArray(errors) ? errors : [errors];
    return __values(list).forEach(e => (dispatch({ type: REMOVE_ERROR_MESSAGE, id: e })));
};
